import React from 'react';
import TableHeadCell from 'atoms/TableHeadCell/TableHeadCell';
import './TableHeader.scss';

const TableHeader = ({
  headerConfig = [],
  sortable = [],
  sortedBy,
  onSort,
  order,
  className,
}) => {
  return (
    <div className={'header-row py-2 ' + (className ? className : '')}>
      {headerConfig.map((header) => {
        const isSort = sortable.includes(header.id);
        return (
          <TableHeadCell
            key={header.id}
            id={header.id}
            label={header.label}
            isSort={isSort}
            isSorted={sortedBy === header.id}
            onSort={isSort ? onSort : () => {}}
            order={order}
          />
        );
      })}
    </div>
  );
};

export default TableHeader;
